import React from 'react';
import styled from 'styled-components';

function Close() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="#FFF"
        strokeLinecap="square"
        transform="translate(1 1)"
      >
        <line
          x1=".208"
          x2="21.792"
          y1=".208"
          y2="21.792"
        />
        <line
          x1=".208"
          x2="21.792"
          y1=".208"
          y2="21.792"
          transform="matrix(1 0 0 -1 0 22)"
        />
      </g>
    </svg>
  );
}

const Button = styled.button`
  background-color: ${({ theme }) => theme.colours.grey};
  border: none;
  border-radius: 60px;
  padding: 5px;
  width: 42px;
  height: 42px;
  display: grid;
  align-items: center;
  justify-content: center;
  animation: scaleOut ease 0.1s; 
  animation-fill-mode: forwards;     

  &:hover {
    animation: scaleIn ease 0.2s; 
    animation-fill-mode: forwards;     
  }
`;

function CloseButton(props) {
  return (
    <Button
      {...props}
      title="Close Video"
    >
      <Close />
    </Button>
  );
}

export default CloseButton;
